<template>
  <div
    v-if="isAlertShown"
    :class="
      twMerge(
        'flex items-start justify-between space-x-4 rounded-xl border p-4 text-sm',
        types[props.type],
        props.isBlock ? 'w-full' : '',
      )
    "
    role="alert"
  >
    <div class="flex">
      <slot name="icon" :icon-classes="iconClasses">
        <component
          :is="icons[type]"
          :class="iconClasses"
        />
      </slot>
      <div>
        <div
          v-if="$slots.title"
          class="font-semibold"
          :class="{ 'mb-1': $slots.description }"
        >
          <slot name="title" />
        </div>
        <p v-if="$slots.description">
          <slot name="description" />
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import InfoIcon from '~icons/lucide/info'
import CheckIcon from '~icons/lucide/check'
import { ref } from 'vue'
import { twMerge } from 'tailwind-merge'

defineOptions({
  name: 'BaseAlert',
})

const props = defineProps<{
  type: 'warning' | 'error' | 'info' | 'success' | 'neutral' | 'purple'
  isBlock?: boolean
}>()

const types = {
  warning: 'bg-warning-50 text-warning-900 border-warning-300',
  error: 'bg-error-50 text-error-700 border-error-200',
  info: 'bg-primary-50 text-primary-500 border-primary-200',
  success: 'bg-success-50 text-success-700 border-success-200',
  neutral: 'bg-neutral-50 text-neutral-700 border-neutral-200',
  purple: 'bg-secondary-50 text-secondary-700 border-secondary-200',
}

const icons = {
  warning: InfoIcon,
  error: InfoIcon,
  info: InfoIcon,
  success: CheckIcon,
  neutral: InfoIcon,
  purple: InfoIcon,
}

const iconClasses = 'mt-0.5 mr-2 hidden h-4 w-4 shrink-0 sm:block'

const isAlertShown = ref(true)
</script>
